(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
  typeof define === 'function' && define.amd ? define('@fdn/button_login_signup', ['react'], factory) :
  (global = global || self, global['@fdn/button_login_signup'] = factory(global.React));
}(this, (function (React) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  var Desktop = function Desktop(props) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, props.onClick ? /*#__PURE__*/React.createElement("button", {
      id: props.element_id,
      className: "btn-login".concat(props.default_class ? " ".concat(props.default_class) : ''),
      onClick: props.onClick
    }, props.text) : /*#__PURE__*/React.createElement("a", {
      id: props.element_id,
      className: "btn-login".concat(props.default_class ? " ".concat(props.default_class) : ''),
      href: props.link
    }, props.text), /*#__PURE__*/React.createElement("style", null, "\n          .btn-login {\n            padding: 8px 16px;\n            border: 1px solid ".concat(props.type === 'monochrome' ? '#000' : '#D7244E', ";\n            border-radius: ").concat(props.type === 'monochrome' ? '0' : '4px', ";\n            color: ").concat(props.type === 'monochrome' ? '#000' : '#D7244E', ";\n            background-color: #FFF;\n            transition: all .2s ease-out;\n            cursor: pointer;\n            font-family: Poppins, sans-serif;\n            font-weight: 500;\n            font-size: 14px;\n            line-height: 21px;\n            text-decoration: none;\n          }\n\n          .btn-login:hover {\n            background-color: ").concat(props.type === 'monochrome' ? '#000' : '#D7244E', ";\n            color: #FFF;\n          }\n        ")));
  };

  var Mobile = function Mobile(props) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, props.onClick ? /*#__PURE__*/React.createElement("button", {
      id: props.element_id,
      className: "btn-login".concat(props.default_class ? " ".concat(props.default_class) : ''),
      onClick: props.onClick
    }, props.text) : /*#__PURE__*/React.createElement("a", {
      id: props.element_id,
      className: "btn-login".concat(props.default_class ? " ".concat(props.default_class) : ''),
      href: props.link
    }, props.text), /*#__PURE__*/React.createElement("style", null, "\n          .btn-login {\n            font-family: Poppins, sans-serif;\n            font-size: 16px;\n            line-height: 26px;\n            color: #FFF;\n            font-weight: 500;\n            letter-spacing: 0.04em;\n            display: block;\n            text-align: center;\n            text-decoration: none;\n            padding: 9px;\n            border-radius: 4px;\n            background-color: #D7244E;\n            border: none;\n            width: 100%;\n          }\n        "));
  };

  var ButtonLoginSignup = function ButtonLoginSignup(_ref) {
    var is_mobile = _ref.is_mobile,
        text = _ref.text,
        link = _ref.link,
        element_id = _ref.element_id,
        default_class = _ref.default_class,
        type = _ref.type,
        onClick = _ref.onClick;
    var props = {
      is_mobile: is_mobile || false,
      text: text || "",
      link: link || null,
      element_id: element_id || null,
      default_class: default_class || "",
      type: type || null,
      onClick: onClick || null
    };

    if (is_mobile) {
      return /*#__PURE__*/React.createElement(Mobile, props);
    } else {
      return /*#__PURE__*/React.createElement(Desktop, props);
    }
  };

  return ButtonLoginSignup;

})));
//# sourceMappingURL=button_login_signup.umd.js.map
